<template>
  <div class="image-chart" :style="{
    width: config.chartWidth + 'px',
    height: config.chartHeight + 'px',
  }">
    <img v-if="imgUrl" class="image-chart-img" :src="imgUrl" alt=""
         :style="{ display: 'inline-block', width: '100%', height: '100%' }" />
  </div>
</template>

<script>
import ChartMixin from './mixin'
import { imgURLtoBase64 } from '@/utils/common'

export default {
  name: 'ImageBlock',
  mixins: [ChartMixin],
  data () {
    return {
      imgUrl: '',
    }
  },
  computed: {

    chartStyle () {
      return this.config.chartSet.chartStyle
    },
    chartData () {
      return this.config.chartViewData.chartData
    },

  },
  watch: {
    chartData: {
      handler: function (val) {
        this.init()
      },
      deep: true,
    },
    // 配置项变更
    config: {
      handler: function () {
        this.init()
      },
      deep: true,
    },

  },
  async created () {
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      const imgUrl = this.chartData.length > 1 ? this.chartData[1].col_0 : ''
      this.imgUrl = await imgURLtoBase64(imgUrl)
    },

  },
}
</script>

<style lang='scss' scoped>
.image-chart {
  display: flex;
  flex-direction: column;
  .image-chart-img{
    width: 100%;
    height: 100%;
    user-select: none;
    -webkit-user-drag: none;
  }
}
</style>
